/* globals CKEDITOR, $, I, L, cflag, webserverRoot, orgArea, orgCompleteListsArea */
// NOTE: this should be the only place that use eslint globals escape.
// Play nice with global variables. So, all linters can work better.
import jQuery from 'jquery'
import 'ckeditor-core'
import update, { extend } from 'immutability-helper'

extend(
  '$pushx',
  (value, object) => update(object || [], { $push: value })
)

export var CKEDITOR =  window.CKEDITOR;
export var $ =  jQuery;
export var I = s => s;
export var L = s => s;

// Global storage for specific flags that need to be accessible everywhere
var globalFlags = {
  'CKEDITOR_VERSION_5': false // Default value for the CKEditor 5 flag
};

var cflag = {}; 
cflag.IsActive = function( flag ){
  var c = cflag
  , chunks
  , i
  , v
  ;
  // console.log('flag >>>>>> global= ',flag);
  if ( !flag ) {
    return false;
  }
  chunks = flag.split(".");
  for (i=0; i<chunks.length; i++) {
    v = c[chunks[i]];
    switch (typeof v) {
    case 'object':
      c = v;
      break;
    case 'boolean':
      return v;
    default:
      return false;
    }
  }
  return false;
}

// Utility function to get specific flag values
export const getCKEditorFlag = () => {
  // First check if the specific flag exists in cflag
  if (cflag.IsActive && cflag.IsActive("2025-07-07.CEN-1874.CKEDITOR.version.5")) {
    return true;
  }
  // Fallback to global storage
  return globalFlags['CKEDITOR_VERSION_5'];
};

// Utility function to set the CKEditor flag
export const setCKEditorFlag = (value) => {
  globalFlags['CKEDITOR_VERSION_5'] = value;
  // Also try to set it in the cflag structure if it exists
  if (cflag && typeof cflag === 'object') {
    // Create nested structure for the flag
    if (!cflag['2025-07-07']) cflag['2025-07-07'] = {};
    if (!cflag['2025-07-07']['CEN-1874']) cflag['2025-07-07']['CEN-1874'] = {};
    if (!cflag['2025-07-07']['CEN-1874']['CKEDITOR']) cflag['2025-07-07']['CEN-1874']['CKEDITOR'] = {};
    if (!cflag['2025-07-07']['CEN-1874']['CKEDITOR']['version']) cflag['2025-07-07']['CEN-1874']['CKEDITOR']['version'] = {};
    cflag['2025-07-07']['CEN-1874']['CKEDITOR']['version']['5'] = value;
  }
};

//Note(all): global.cflag is set in the cflags.html template file
export var cflag = global.cflag || cflag;
export var webserverRoot = window.location.protocol + "//" +window.location.hostname + process.env.PATH_PREFIX + "Cention/web/";;
export var orgArea = window.orgArea;
export var  orgCompleteListsArea = window.orgCompleteListsArea;